import { CSSProperties, FC, ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Page } from './style'

const TRAINING_NO_SELECT_BODY_CLASS = 'training-no-text-select-root'

const isTrainingRoute = (pathname: string): boolean =>
	pathname === '/training_constructor' ||
	pathname === '/workout_history' ||
	pathname === '/history_workout' ||
	pathname === '/recently_seen_workouts' ||
	pathname.startsWith('/exercise/') ||
	pathname.startsWith('/training/') ||
	/^\/program\/[^/]+\/week\/[^/]+\/day\/[^/]+\/history$/.test(pathname) ||
	/^\/program\/[^/]+\/training(?:\/|$)/.test(pathname)

export const DefaultPage: FC<{
	children: ReactNode
	style?: CSSProperties
	className?: string
	noPadding?: boolean
	id?: string
}> = ({ children, style, noPadding = false, className }) => {
	const { pathname } = useLocation()
	const isTrainingNoSelect = isTrainingRoute(pathname)
	const pageClassName = [
		className,
		isTrainingNoSelect ? 'training-no-text-select' : '',
	]
		.filter(Boolean)
		.join(' ')

	useEffect(() => {
		if (!isTrainingNoSelect) {
			return
		}

		const preventImageAction = (event: Event) => {
			if (event.target instanceof HTMLElement && event.target.closest('img')) {
				event.preventDefault()
			}
		}

		document.body.classList.add(TRAINING_NO_SELECT_BODY_CLASS)
		document.addEventListener('dragstart', preventImageAction)
		document.addEventListener('contextmenu', preventImageAction)

		return () => {
			document.body.classList.remove(TRAINING_NO_SELECT_BODY_CLASS)
			document.removeEventListener('dragstart', preventImageAction)
			document.removeEventListener('contextmenu', preventImageAction)
		}
	}, [isTrainingNoSelect])

	return (
		<Page style={{ padding: noPadding ? 0 : '15px 16px', ...style }} className={pageClassName}>
			{children}
		</Page>
	)
}
